<template>
    <div class="personal-layout">
        <web-nav></web-nav>
        <main class="personal-shell">
            <div class="personal-breadcrumb"><span>首页</span><i class="el-icon-arrow-right"></i><span>个人中心</span><i class="el-icon-arrow-right"></i><strong>{{currentPage.title}}</strong></div>
            <header class="personal-hero">
                <div class="hero-profile">
                    <img v-if="profile.avatar" :src="eUtils.imgUrl + profile.avatar" alt="个人头像" class="profile-avatar">
                    <div v-else class="profile-avatar profile-avatar-empty">{{(profile.nickname || '我').slice(0, 1)}}</div>
                    <div class="profile-copy"><span class="hero-kicker">MY ACCOUNT</span><h1>{{profile.nickname || '个人中心'}}</h1><p>管理个人资料、订单与账户服务</p></div>
                </div>
                <div class="hero-identity" v-if="identityName"><i class="el-icon-collection"></i><span>当前题库</span><strong>{{identityName}}</strong></div>
                <div class="hero-decoration" aria-hidden="true"></div>
            </header>
            <div class="personal-columns">
                <nav class="personal-sidebar" aria-label="个人中心导航">
                    <div class="sidebar-heading">个人中心<span>ACCOUNT</span></div>
                    <div class="sidebar-group" v-for="group in menuGroups" :key="group.title">
                        <div class="sidebar-group-title">{{group.title}}</div>
                        <button v-for="item in group.items" :key="item.path" type="button" class="sidebar-item" :class="{active: $route.path === item.path}" :aria-current="$route.path === item.path ? 'page' : null" @click="goRouter(item.path)">
                            <i :class="item.icon"></i><span>{{item.title}}</span><i class="el-icon-arrow-right sidebar-arrow"></i>
                        </button>
                    </div>
                </nav>
                <section class="personal-workspace" :aria-label="currentPage.title">
                    <div class="workspace-heading"><span class="workspace-kicker">{{currentPage.kicker}}</span><h2>{{currentPage.title}}</h2><p>{{currentPage.description}}</p></div>
                    <router-view></router-view>
                </section>
            </div>
        </main>
        <bottom></bottom>
    </div>
</template>

<script>
import webNav from '@/components/webNav'
import bottom from '@/components/bottom'
import {mapGetters} from 'vuex'

const menuGroups = [
    {title:'账户管理',items:[
        {path:'/personalCenter',title:'个人信息',icon:'el-icon-user',kicker:'PROFILE',description:'完善资料，管理邮箱、手机号与登录密码'},
        {path:'/myOrderList',title:'我的订单',icon:'el-icon-document',kicker:'ORDERS',description:'查看购买记录和订单详情'},
        {path:'/mySlash',title:'我的斩题',icon:'el-icon-collection-tag',kicker:'MY SLASHED QUESTIONS',description:'按题库与章节回顾和管理已斩题目'},
        {path:'/address',title:'收货地址',icon:'el-icon-location-outline',kicker:'ADDRESSES',description:'管理图书与商品的收货地址'},
        {path:'/paymentMethod',title:'收款方式',icon:'el-icon-bank-card',kicker:'PAYMENT METHODS',description:'管理邀请奖励的收款账户'},
        {path:'/myCoupons',title:'我的优惠券',icon:'el-icon-tickets',kicker:'COUPONS',description:'查看、兑换和转赠优惠券'},
        {path:'/myInvitation',title:'我的邀请',icon:'el-icon-present',kicker:'INVITATIONS',description:'分享邀请码，查看邀请奖励与返现记录'}
    ]},
    {title:'社区互动',items:[
        {path:'/followWith',title:'我的关注',icon:'el-icon-star-off',kicker:'FOLLOWING',description:'查看关注的人和关注我的人'},
        {path:'/commentOfMe',title:'评论我',icon:'el-icon-chat-dot-round',kicker:'REPLIES',description:'查看收到的评论与回复'},
        {path:'/myComment',title:'我评论',icon:'el-icon-chat-line-square',kicker:'MY COMMENTS',description:'回顾在题库、题单和论坛中的评论'},
        {path:'/notice',title:'通知消息',icon:'el-icon-bell',kicker:'NOTIFICATIONS',description:'查看系统消息与互动提醒'}
    ]},
    {title:'帮助支持',items:[
        {path:'/service',title:'联系客服',icon:'el-icon-service',kicker:'SUPPORT',description:'扫码联系上考客服'},
        {path:'/feedback',title:'意见反馈',icon:'el-icon-edit-outline',kicker:'FEEDBACK',description:'告诉我们使用中遇到的问题或建议'}
    ]}
]

export default {
    name:'personalLayout',
    components:{webNav,bottom},
    data(){return {eUtils:EUtils,menuGroups}},
    computed:{
        ...mapGetters(['userInfo','identityName']),
        profile(){return this.userInfo || {}},
        currentPage(){
            return this.menuGroups.flatMap(group=>group.items).find(item=>item.path===this.$route.path) || this.menuGroups[0].items[0]
        }
    },
    methods:{
        goRouter(path){
            if(this.$route.path !== path) this.$router.push(path)
        }
    }
}
</script>

<style lang="scss">
@use './personalWorkspace.scss';
</style>
